/*JM Added for cfaq banner image*/
jQuery(document).ready(function($) {
  $( ".index-section.index-section--faq" ).append( "<img src='https://cdn.shopify.com/s/files/1/1633/6641/files/faq-banner.webp?v=1658845741' width='100%' class='lazyautosizes lazyloaded' alt='Altenew' data-sizes='auto' sizes='272px'>" );
});

/*JM Added for collection page drawer clear all filter*/
$(document).ready(function() {
   var uri = window.location.toString();
   setInterval(function () {
       if (window.location.href.indexOf("?filter") > -1) {
              $('#clear-all-button').on("click", function(){
              var clean_uri = uri.substring(0, uri.indexOf("?"));
              window.location.href = window.location.href.split('?')[0]; 
    		});
			$("#clear-all-button").css("display","block");
       }else{
       	$("#clear-all-button").css("display","none");
       }
    },1000);
});

//JM Added for 404 error image
jQuery(document).ready(function($) {
  $( "header.section-header.section-header--404" ).append( "<a href='https://wholesale.altenew.com/'><img src='https://cdn.shopify.com/s/files/1/1633/6641/files/Altnew-404-Page-Banner.jpg?v=1659018449' width='100%' class='lazyautosizes lazyloaded' alt='Altenew' data-sizes='auto' sizes='272px'></a>" );
});

//Klaviyo update text on collection list 
jQuery(document).ready(function ($) {
$(".klaviyo-product-container.jm-custom-klaviyo a.btn.klaviyo-bis-trigger").html("<svg style='color: #3c3c3c' xmlns='http://www.w3.org/2000/svg' width='17' height='17' fill='currentColor' class='bi bi-envelope' viewBox='0 0 16 16'> <path d='M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z' fill='#3c3c3c'></path> </svg>Notify Me");
$(".klaviyo-product-container.jm-custom-klaviyo .klaviyo-button-container").css("position","unset");
});

/*Option 1 for products with a lot of images horizontal view*/
$( document ).ready(function() {
    $( ".template-product .product-section .product__thumbs--below .product__thumb-item" ).each(function() {
	  var getCount = $(this).attr('data-index');
	  if(getCount > 14){
	  $(".template-product .product-section .product__thumbs--below").css({
			 'max-height': '300px',
		    'overflow-x': 'hidden',
		    'overflow-y': 'scroll'
		})
	}
	});
});

// /*Hide/Show Notify Me When Available For Variant Options 03-8-2023*/
//  $( document ).ready(function() {
//    var PDP_btn_text = $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text();
//    if ($.trim(PDP_btn_text) == "Add to cart"){
//            $("#notify-me-variant-options").css("display","none");
//            $(".jmc-cart-wishlist.left .variant-input-wrap select option").removeAttr("disabled");
//       }else{
//          $("#notify-me-variant-options").css("display","block");
//          $(".jmc-cart-wishlist.left .variant-input-wrap select option").attr("disabled","disabled");
//       }
//    $('.jmc-cart-wishlist.left .variant-input-wrap select').on('change', function() { 
//          var PDP_btn_text = $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text();
//          if (PDP_btn_text == "Sold Out"){
//            $("#notify-me-variant-options").css("display","block");
//            $(".inventoryWrapper").css("display","none");
//          }else {
//            $(".inventoryWrapper").css("display","block");
//          }
//      console.log(PDP_btn_text);
//   });
// });

/*Collection Page fix Notify Me button missing when using filter 5-4-2023*/
$(document).ready(function () {
    $("div#FilterDrawer li.tag").click(function () {
      setTimeout(function() {
     location.reload(true);
    }, 1000);
    });
});

/*Add target blank to all external links 5-5-2023*/
 $( document ).ready(function() {
  // Get all links in the menu list
  const menuLinks = document.querySelectorAll('ul.site-nav.site-navigation.small--hide a');
  
  // Loop through the links
  menuLinks.forEach(link => {
    // Check if the link is an external link
    if (link.hostname !== window.location.hostname) {
      // Add the target="_blank" attribute
      link.setAttribute('target', '_blank');
    }
  });
});

 $( document ).ready(function() {
  // Get all links in the menu list
  const menumobLinks = document.querySelectorAll('ul.mobile-nav.mobile-nav--heading-style a');
  
  // Loop through the links
  menumobLinks.forEach(link => {
    // Check if the link is an external link
    if (link.hostname !== window.location.hostname) {
      // Add the target="_blank" attribute
      link.setAttribute('target', '_blank');
    }
  });
});

/*SMS Subscription Form Wholesale*/
 $(document).ready(function() {
    // Function to disable the button
    function disableButton() {
      $(".klaviyo-form-RfPSZW.klaviyo-form button[aria-label='Search Countries']").prop('disabled', true);
    }
    // Call the function after 3 seconds
    setTimeout(disableButton, 2000); // 3000 milliseconds = 3 seconds
  });

/*Layering guides page custom search 09-28-2023*/
$( document ).ready(function() {
  var acc = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight){
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    }
  }
  
  // Store the input fields as variables
  var $barInput = $('.bar-input');
  var $layeringInstructions = $('.layering-instructions');
  var $layeringStencil = $('.layering-stencil');
  var $pressPlates = $('.press-plates');

  // Reusable function for handling accordions
  function handleAccordion(inputElement, accordionContainer, backgroundColorClass) {
    var inputVal = inputElement.val().toLowerCase();
    var accordions = accordionContainer.find('.accordion');
    var searchCount = 0;

    accordions.each(function () {
      var accordion = $(this);
      var panel = accordion.next('.panel');
      var listItems = panel.find('ul li');
      var matchCount = 0;

      listItems.each(function () {
        var listItem = $(this);
        var textContent = listItem.text().toLowerCase();

        if (!inputVal || textContent.indexOf(inputVal) > -1) {
          listItem.css('display', 'list-item');
          matchCount++;
        } else {
          listItem.css('display', 'none');
        }
      });

      if (matchCount === 0) {
        accordion.removeClass('active');
        accordion.removeClass(backgroundColorClass);
        panel.css('max-height', '0'); // Close the panel
      } else {
        accordion.addClass('active'); // Add 'active' class
        accordion.addClass(backgroundColorClass); // Add background color class
        panel.css('max-height', '1000px'); // Open the panel (adjust '1000px' as needed)
      }

      searchCount += matchCount;
    });

    if (inputVal === "") {
      accordions.removeClass('active');
      accordions.removeClass(backgroundColorClass);
      accordions.show(); // Show all accordions when the input is empty
      var panels = accordionContainer.find('.panel');
      panels.css('max-height', ''); // Reset max-height for all panels
    } else {
      accordions.not('.active').hide(); // Hide non-active accordions
    }

    if (searchCount < 318 && searchCount !== 0) {
      accordionContainer.find('.no-results').css("display", "none");
    } else if (searchCount === 0) {
      accordionContainer.find('.no-results').css("display", "block");
    }
  }

  // Attach event handlers
  $barInput.on('keyup', function () {
    handleAccordion($barInput, $('#layering-guides'), 'background-color-class1');
  });

  $layeringInstructions.on('keyup', function () {
    handleAccordion($layeringInstructions, $('#layering-instructions'), 'background-color-class2');
  });

  $layeringStencil.on('keyup', function () {
    handleAccordion($layeringStencil, $('#layering-stencil'), 'background-color-class3');
  });

   $pressPlates.on('keyup', function () {
    handleAccordion($pressPlates, $('#press-plates'), 'background-color-class3');
  });


  
  /*All links open in new tab 12/10/2024*/
  $('#layering-guides a, #layering-instructions a, #layering-stencil a, #marvelous-monthly-series a','#press-plates a').attr('target', '_blank');
  
});

/*Update the new/best/sale menu link*/
$(document).ready(function() {
    // Define the target URL
    var targetUrl = 'https://wholesale.altenew.com/collections/new';

    // Find the anchor tag with the specific href attribute
    var $targetAnchorDesktop = $('div#HeaderWrapper a[href="' + targetUrl + '"]');

    // Check if the anchor tag with the specified URL exists
    if ($targetAnchorDesktop.length > 0) {
      // Update the text content
      $targetAnchorDesktop.html('NEW<span class="dot">•</span>BEST <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path></svg>'); // Replace with your desired text
    }
  });

$(document).ready(function() {
    // Define the target URL
    var targetUrl = 'https://wholesale.altenew.com/collections/new';

    // Find the anchor tag with the specific href attribute
    var $targetAnchorMobile = $('.mobile-nav__has-sublist a[href="' + targetUrl + '"]');

    // Check if the anchor tag with the specified URL exists
    if ($targetAnchorMobile.length > 0) {
      // Update the text content
      $targetAnchorMobile.html('NEW<span class="dot">•</span>BEST <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="m1.57 1.59 12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"></path></svg>'); // Replace with your desired text
    }
  });


//Searchnise Product Subscription/Sneak Peak on Search Page
$(document).ready(function () {
   if (window.location.href.indexOf("https://wholesale.altenew.com/pages/search-results-page?q") > -1) {
        setTimeout(function(){
         $('#snize-search-results-grid-mode ul li').each(function () {
         if($(this).hasClass("snize-product-out-of-stock")){
            $("#snize-search-results-grid-mode li.snize-product-out-of-stock .snize-button").html('<svg style="color: #3c3c3c" xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16"> <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" fill="#3c3c3c"></path> </svg> Notify Me');
         }else if($(this).hasClass("snize-product-tag-sneak_peek")) {
            $("#snize-search-results-grid-mode li.snize-product.snize-product-tag-sneak_peek .snize-button").text("More Info");
            $("#snize-search-results-grid-mode li.snize-product.snize-product-tag-sneak_peek .snize-button").removeClass( "snize-add-to-cart-button");
          }else if($(this).hasClass("snize-product-tag-promo_ink-cube")) {
            $("#snize-search-results-grid-mode li.snize-product.snize-product-tag-promo_ink-cube .snize-button").text("More Info");
            $("#snize-search-results-grid-mode li.snize-product.snize-product-tag-promo_ink-cube .snize-button").removeClass( "snize-add-to-cart-button");
          }
         });
        }, 3000); //run this after 3 seconds
  };
});

/*Hide/Show Notify Me When Available For Variant Options improve to handle pre-order options 3-1-2024*/
 $( document ).ready(function() {
   var PDP_btn_text = $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text();
    if ($.trim(PDP_btn_text) == "Add to cart"){
           $("#notify-me-variant-options").css("display","none");
           $(".jmc-cart-wishlist.left .variant-input-wrap select option").removeAttr("disabled");
      }else{
         $("#notify-me-variant-options").css("display","block");
         $(".jmc-cart-wishlist.left .variant-input-wrap select option").removeAttr("disabled");
         $(".inventoryWrapper").css("display","none");
      }
   
       // Function to synchronize selections between Select 1 and Select 2
        function syncSelectOptions() {
            // Get the selected index from Select 1
            var selectedIndex = $('.variant-wrapper.variant-wrapper--dropdown .variant-input-wrap select').prop('selectedIndex');
            // Set the corresponding option in Select 2 as selected
            $('select.product-single__variants.no-js').prop('selectedIndex', selectedIndex);
        }

        // Run the function when the page loads
        syncSelectOptions();

   
          // Function to check the selected option
          function checkSelectedOption() {
               var selectedOption = $('option:selected', 'select.product-single__variants.no-js');
               var attributeValue = selectedOption.attr('continuesellingoos');
               var ProductTypeJM = $("input.ProductTypeJM").val();
               var PreOrderJM = $("input.PreOrderJM").val();
               var RegisterJM = $("input.RegisterJM").val();
               var JoinWaitListJM = $("input.JoinWaitListJM").val();
                 if(attributeValue=="continue"){
                   if (ProductTypeJM !== "Class" && ProductTypeJM !== "Class Bundle" && ProductTypeJM !== "Workshop"  && ProductTypeJM !== "Gift Cards" && RegisterJM === "false")  {
                     $("h2.shipping-period").css("display","block");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("Pre-Order");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary").prop('disabled', false);
                     $("div#custom-sticky-header-jm button").prop('disabled', false);
                     $("div#custom-sticky-header-jm button span").text("PRE-ORDER");
                     $("div#custom-sticky-header-jm button").css("background-color","#000");
                     $("div#custom-sticky-header-jm button").css("color","#FFFFFF");
                   }else if(RegisterJM == "true"){
                      $("h2.shipping-period").css("display","block");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("Register");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary").prop('disabled', false);
                     $("div#custom-sticky-header-jm button").prop('disabled', false);
                     $("div#custom-sticky-header-jm button span").text("REGISTER");
                     $("div#custom-sticky-header-jm button").css("background-color","#000");
                     $("div#custom-sticky-header-jm button").css("color","#FFFFFF");
                   }
                   else if(JoinWaitListJM == "true"){
                      $("h2.shipping-period").css("display","block");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("Join Waitlist");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary").prop('disabled', false);
                     $("div#custom-sticky-header-jm button").prop('disabled', false);
                     $("div#custom-sticky-header-jm button span").text("Join Waitlist");
                     $("div#custom-sticky-header-jm button").css("background-color","#000");
                     $("div#custom-sticky-header-jm button").css("color","#FFFFFF");
                }
                 }else if(attributeValue=="deny"){
                   $("h2.shipping-period").css("display","none");
                   $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("Add to Cart");
                   $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary").prop('disabled', false);
                     $("div#custom-sticky-header-jm button").prop('disabled', false);
                     $("div#custom-sticky-header-jm button span").text("ADD TO CART");
                     $("div#custom-sticky-header-jm button").css("background-color","#000");
                     $("div#custom-sticky-header-jm button").css("color","#FFFFFF");
                 }else {
                   if(attributeValue=="oos" && JoinWaitListJM != "true"){
                    $("h2.shipping-period").css("display","none");
                    $("#notify-me-variant-options").css("display","block");
                    $(".inventoryWrapper").css("display","none");
                    $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary span").text("SOLD OUT");
                     $(".jmc-cart-wishlist.right button.btn.btn--full.add-to-cart.btn--secondary").prop('disabled', true);
                     $("div#custom-sticky-header-jm button").prop('disabled', true);
                     $("div#custom-sticky-header-jm button span").text("SOLD OUT");
                     $("div#custom-sticky-header-jm button").css("background-color","#d3d3d3");
                    $("div#custom-sticky-header-jm button").css("border","1px solid #d3d3d3");
                     $("div#custom-sticky-header-jm button").css("color","#3c3c3c");
                  }else if(attributeValue=="oos" && JoinWaitListJM == "true"){
                     $(".product-single__form .add-to-cart.btn--secondary:disabled").css("display","none");
                  }
              }
          }
    // Attach change event handler
    $('select.product-single__variants.no-js').change(function() {
      checkSelectedOption();
    });
    setTimeout(function() { 
      checkSelectedOption();
      }, 3000);
});


/*Hide sub-collection title on selected collections 7-11-2024*/
 $( document ).ready(function() {
  var collectionURL = $(location).attr("href");
  if (collectionURL == "https://wholesale.altenew.com/collections/new") {
    $("div#subCollection-list .collection-item--below .collection-item__title").css("display","none");
  }
});

/*Update the Privacy Policy Page Title*/
 $(document).ready(function () {
    let titlePrivacyPolicy = $(".shopify-policy__title h1");
    let titledatasalesoptOut = $("header.hc-header.section-header h1.section-header__title");
    let titledatasalesoptOutnav = $("nav.breadcrumb span:nth-child(3)");
   
    if (titlePrivacyPolicy.text().trim() === "Privacy policy") {
        titlePrivacyPolicy.text("Privacy Notice");
    }

    if (titledatasalesoptOut.text().trim() === "Do not sell or share my personal information") {
        titledatasalesoptOut.text("Do Not Sell or Share My Personal Data");
    }

    if (titledatasalesoptOutnav.text().trim() === "Do not sell or share my personal information") {
        titledatasalesoptOutnav.text("Do Not Sell or Share My Personal Data");
    }

});

/*Move bundle discount AOV widget before the description PDP 4/30/2025*/
$(document).ready(function(){
  $(".Avada-Bundle-Offer__Volume").css ("margin-bottom","15px");
  setTimeout(function() { 
  $(".Avada-Bundle-Offer__Volume").insertBefore("div#jm-desc-block-wh");
  }, 3000);
});

/*JM added for bundle listing description will show 5/2/2025*/
$(document).ready(function () {
  var firstLoad = true;

  function updateSelectedIndex() {
    var selectedIndex = $('.variant-wrapper.variant-wrapper--dropdown .variant-input-wrap select option:selected').index()+1;

    // Hide all tabcontent elements with data-index
    $('.tabcontent[data-index]').hide().addClass('hc-hidden');

    // Show the matching one
    var $targetTab = $('.tabcontent[data-index="' + selectedIndex + '"]');
    $targetTab.show();

    // Handle height adjustment and visibility
    function showAndAdjust() {
      // Hide others just in case
      $('.tabcontent[data-index]').not('[data-index="' + selectedIndex + '"]').css('display', 'none');

      // Reveal the selected one properly
      $targetTab.removeClass('hc-hidden').css('display', 'contents');

      var $activeContentInner = $targetTab.find('.collapsible-content__inner.rte');
      var contentHeight = $activeContentInner.outerHeight(true);

      $('#jm-desc-block .single__meta_desc').css('height', 'auto').height(contentHeight);
    }

    // Delay only on first load
    if (firstLoad) {
      setTimeout(showAndAdjust, 3000);
      firstLoad = false; // Ensure delay doesn't happen again
    } else {
      showAndAdjust();
    }
  }

  // Run on page load
  updateSelectedIndex();

  // Run on change
  $('.variant-wrapper.variant-wrapper--dropdown .variant-input-wrap select').on('change', updateSelectedIndex);
});

/*AOV Bundle Feature Alternative solution for now for the products reflect on cart*/
$(document).ready(function() {
  $(document).on('click', 'button.Avada-Offer__ButtonAddToCart', function() {
    setTimeout(function() {
      if ($('button.Avada-Offer__ButtonAddToCart').is(':visible')) {
         location.reload();
      }
    }, 3500);
  });
});

/*Cart drawer item remove 5/22/2025*/
  $(document).on('click', '.remove-cart-item', function(e) {
  e.preventDefault();
  const $cartItem = $(this).closest('.cart__item');
  const $qtyWrapper = $cartItem.find('.js-qty__wrapper');
  const $input = $qtyWrapper.find('.js-qty__num');
  const $minusBtn = $qtyWrapper.find('.js-qty__adjust--minus');

  // Set quantity to 0 and trigger native minus click
  $input.val(0);
  $minusBtn.trigger('click');
});